import { createFileRoute, redirect } from "@tanstack/react-router";
import { productSlugRedirectUrl } from "@/components/inventory/FilterRedirects";
import { pageHead } from "@/lib/routeHead";

// /product/<slug> used to render the unit detail page, duplicating
// /rv-search/<slug>. It now 301s to the canonical unit URL.
export const Route = createFileRoute("/product/$slug/")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/product/:slug' }),
  beforeLoad: ({ params }) => {
    throw redirect({
      href: productSlugRedirectUrl(params.slug),
      statusCode: 301,
      throw: true,
    });
  },
});
